import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/basicExcelTemplate/selectList',
    method: 'get',
    params: data,
  });
}

export function save(data) {
  return request({
    url: '/basicExcelTemplate',
    method: 'post',
    data: data,
  });
}

export function detail(data) {
  return request({
    url: '/basicExcelTemplate',
    method: 'get',
    params: data,
  });
}
// 获取路径
export function getPath(data) {
  return request({
    url: '/basicExcelTemplate/getPath',
    method: 'get',
    params: data,
  });
}

